<div class="modal-header">
  <h4 class="modal-title">Attachment Email</h4>
</div>
<div class="modal-body">
  <div class="d-flex" style="margin-top: 15px">
    <div>
      <label class="mt-2 me-2">Send To</label>
    </div>
    <div>
      <dx-select-box
        [(value)]="selectedCommitteeId"
        [items]="committees"
        [valueExpr]="'id'"
        [displayExpr]="'name'"
        (onSelectionChanged)="selectionChanged($event)"
      ></dx-select-box>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    {{ !!members ? members.length + ' people' : '' }}
  </div>

  @if (members) {
    <div class="widget-content user">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Person</th>
            <th>Email</th>
            <th>Cell</th>
          </tr>
        </thead>
        <tbody>
          <tr [hidden]="members.length > 0">
            <td colspan="9">No items</td>
          </tr>
          @for (member of members; track member) {
            <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="members.length === 0">
              <td style="padding: 6px">{{ member.person.displayName }}</td>
              <td style="padding: 6px">{{ member.person.email }}</td>
              <td style="padding: 6px">{{ member.person.cellPhone }}</td>
              <td style="padding: 6px"><i class="fa fa-times" (click)="remove(member.personId)"></i></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  @if (attachmentArray) {
    <div class="widget-content user">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Attachment</th>
          </tr>
        </thead>
        <tbody>
          <tr [hidden]="attachmentArray.length > 0">
            <td colspan="9">No attachments</td>
          </tr>
          @for (attachment of attachmentArray; track attachment) {
            <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="attachmentArray.length === 0">
              <td style="padding: 6px">{{ attachment }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="processing">Send Email</button>
  <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
</div>
